$(function () {
    $(window).on('resize', function() {
        let is_small_screen = window.innerWidth <= 768;
        if (!is_small_screen) {
            $('.100vh').css('height', window.innerHeight + 'px'); // 100vh header fixen voor safari
        } else {
            $('.100vh').css('height', '');
        }
        homepageheader();
    });

    homepageheader();

    function homepageheader () {
        let height = window.innerHeight;
        height -= $('.homepageheader__logo--wrapper').outerHeight(true);
        $('.homepageheader__desktop').css('height', height + 'px');
    }
});
